module.exports = __webpack_public_path__ + "img/hjortronblom.e922fb71.jpg";